/**
 * "Delete these rows?" — the confirmation behind Del. A soft delete (PLAN
 * §6.1): the rows and everything under them disappear from the rundown, and
 * undo brings them back.
 */
import { Button } from '../ui/button.js';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog.js';

export type DeleteRowsDialogProps = {
  readonly open: boolean;
  /** What is being deleted, as the tree names it. */
  readonly names: readonly string[];
  readonly onConfirm: () => void;
  readonly onOpenChange: (open: boolean) => void;
};

export function DeleteRowsDialog({ open, names, onConfirm, onOpenChange }: DeleteRowsDialogProps) {
  const title = names.length === 1 ? `Delete “${names[0] ?? ''}”?` : `Delete ${String(names.length)} rows?`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>Everything under {names.length === 1 ? 'it' : 'them'} goes too. Undo (Ctrl+Z) brings it back.</DialogDescription>
          </DialogHeader>
          {names.length > 1 ? (
            <ul className="max-h-40 list-disc overflow-auto pl-6 text-sm" data-testid="delete-names">
              {names.map((n, i) => (
                <li key={`${String(i)}-${n}`}>{n}</li>
              ))}
            </ul>
          ) : null}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" variant="destructive" autoFocus data-testid="confirm-delete">
              Delete
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
